var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemeberhsipScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#155EEF",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8877 18.8967C27.2827 18.7007 28.3567 17.5047 28.3597 16.0557C28.3597 14.6277 27.3187 13.4437 25.9537 13.2197",
    stroke: "#155EEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7285 22.2503C29.0795 22.4523 30.0225 22.9253 30.0225 23.9003C30.0225 24.5713 29.5785 25.0073 28.8605 25.2813",
    stroke: "#155EEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8867 22.6638C16.6727 22.6638 13.9277 23.1508 13.9277 25.0958C13.9277 27.0398 16.6557 27.5408 19.8867 27.5408C23.1007 27.5408 25.8447 27.0588 25.8447 25.1128C25.8447 23.1668 23.1177 22.6638 19.8867 22.6638Z",
    stroke: "#155EEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8867 19.8879C21.9957 19.8879 23.7057 18.1789 23.7057 16.0689C23.7057 13.9599 21.9957 12.2499 19.8867 12.2499C17.7777 12.2499 16.0677 13.9599 16.0677 16.0689C16.0597 18.1709 17.7567 19.8809 19.8587 19.8879H19.8867Z",
    stroke: "#155EEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8848 18.8967C12.4888 18.7007 11.4158 17.5047 11.4128 16.0557C11.4128 14.6277 12.4538 13.4437 13.8188 13.2197",
    stroke: "#155EEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0439 22.2503C10.6929 22.4523 9.74989 22.9253 9.74989 23.9003C9.74989 24.5713 10.1939 25.0073 10.9119 25.2813",
    stroke: "#155EEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemeberhsipScan);
export default __webpack_public_path__ + "static/media/memeberhsip-scan.391421c2518afcf5965e277b4189194b.svg";
export { ForwardRef as ReactComponent };